import React from "react";
import { Card, Col } from "react-bootstrap";
import {
  Analysts,
  Title,
  PublicationDate,
  Synopsis,
  Tags,
  TopStory,
  FileTypeIcon,
} from "../tileView/PublicationCardParts";
import { ShareButton } from "../../shareMenu/ShareButton";
import "./PublicationCard.scss";

export function PublicationCard({ publication, styles, isTopStory, lang }) {
  return (
    <Col
      key={publication.id}
      lg={publication.lg || 4}
      md={publication.md || 6}
      sm={publication.sm || 6}
      xs={12}
      className="d-flex pb-3 px-2"
    >
      <Card className={`${styles.card || ""} w-100 rounded-0 shadow`} style={styles.cardStyle} lang={lang}>
        <Card.Header className={`${styles.header || ""} border-bottom-0`}>
          {isTopStory && <TopStory />}
          <Analysts lang={lang} {...publication} styles={styles} />
        </Card.Header>

        <Card.Body className={`${styles.body} py-0 publication-synopsis`}>
          <Card.Title className={`${styles.title || ""}`}>
            <Title {...publication} />
          </Card.Title>
          <Synopsis {...publication} styles={styles} />
        </Card.Body>

        <Card.Footer className={`border-top-0 ${styles.footer || ""}`}>
          <Tags {...publication} lang={lang} />
          <PublicationDate {...publication} />
          <FileTypeIcon {...publication} />
          <ShareButton publication={publication} />
        </Card.Footer>
      </Card>
    </Col>
  );
}
